import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { BadgeCheck } from "lucide-react";
import { Reveal } from "./Reveal";
import { useContent } from "../context/ContentContext";
import { mediaUrl } from "../lib/api";

export const About = () => {
  const { content } = useContent();
  const a = content.about;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-6%", "10%"]);

  return (
    <section id="about" data-testid="about-section" className="relative py-20 md:py-28 bg-cream">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div ref={ref} className="lg:col-span-5 order-1">
            <div className="relative">
              <Reveal className="relative rounded-[2rem] overflow-hidden shadow-[0_30px_60px_-24px_rgba(122,143,119,0.4)]">
                <div className="aspect-[4/5] overflow-hidden">
                  <motion.img style={{ y: imgY, scale: 1.12 }} src={mediaUrl(a.image)} alt="Karen Boley, Canadian Certified Counsellor" className="h-full w-full object-cover object-center" />
                </div>
              </Reveal>
              <Reveal delay={0.2} className="absolute -bottom-6 -right-3 md:-right-6 bg-white rounded-2xl px-6 py-5 shadow-xl border border-cream-2 max-w-[15rem]">
                <p className="font-serif text-3xl text-sage-dark leading-none">Karen</p>
                <p className="text-sm text-ink-muted mt-1.5">{a.post}</p>
              </Reveal>
            </div>
          </div>

          <div className="lg:col-span-7 order-2">
            <Reveal>
              <p className="text-xs md:text-sm uppercase tracking-[0.24em] font-semibold text-ocean">{a.eyebrow}</p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-4 font-serif font-light text-4xl md:text-5xl lg:text-6xl tracking-tight text-ink leading-[1.05]">
                {a.headingLead}<span className="text-sage-dark">{a.headingAccent}</span>
              </h2>
            </Reveal>

            <div className="mt-8 space-y-5 max-w-2xl">
              {(a.paragraphs || []).map((p, i) => (
                <Reveal key={i} delay={0.12 + i * 0.05}>
                  <p className="text-base md:text-lg text-ink-soft leading-relaxed">{p}</p>
                </Reveal>
              ))}
            </div>

            <Reveal delay={0.2}>
              <div className="mt-10 flex flex-wrap gap-3">
                {(a.credentials || []).map((c) => (
                  <span key={c} className="inline-flex items-center gap-1.5 rounded-full bg-sage/12 border border-sage/30 px-4 py-2 text-sm font-medium text-sage-dark">
                    <BadgeCheck className="h-4 w-4" /> {c}
                  </span>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
